// extracted by mini-css-extract-plugin
module.exports = {"nav":"style_nav__5YSrw","mobile":"style_mobile__71Bmb","list":"style_list__biQNy","item":"style_item__0WtkA","active":"style_active__5f5Pj"};